module.exports = __webpack_public_path__ + "static/media/downloadIcon.2dcd3905.png";